import { makeStyles } from "@material-ui/core/styles";
export default makeStyles(theme => ({
    row: {
        margin: "30px 0"
    },
    logoRow: {
        margin: 15
    },
    logoWrapper: { border: "1px solid #ccc", borderRadius: 10, padding: 10 },
    logo: {
        maxWidth: "100%"
    },
    paper: {
        maxWidth: 960,
        margin: "30px auto",
        padding: 15
    },
    storeLogos: {
        maxWidth: "100%"
    }
}));
